// features/usage/components/UsageDashboard.tsx
export default function UsageDashboard() {
  return (
    <section className="space-y-6">
      {/* Smaller heading */}
      <h1 className="text-xl font-semibold text-neutral-100">Usage</h1>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {/* each card with slightly smaller radius (rounded-lg) */}
        <div className="rounded-md bg-neutral-900 p-4 border border-neutral-800">
          <p className="text-xs text-neutral-400">Total spend</p>
          <p className="text-2xl font-semibold mt-2">$ 2.72</p>
        </div>

        {/* …replicate for tokens, requests, chart, etc. */}
      </div>
    </section>
  );
}